import { render, staticRenderFns } from "./AlertManagment.vue?vue&type=template&id=50552857&scoped=true"
import script from "./AlertManagment.vue?vue&type=script&lang=js"
export * from "./AlertManagment.vue?vue&type=script&lang=js"
import style0 from "./AlertManagment.vue?vue&type=style&index=0&id=50552857&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50552857",
  null
  
)

export default component.exports